import { MDBAlert, MDBBtn, MDBDatatable, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBSpinner } from 'mdb-react-ui-kit';
import React, { useEffect, useRef, useState } from 'react'
import { Tooltip } from 'react-tooltip';
import { getPortingDetails, getPortingStatusDetails, uploadCobFile } from '../../apiclients/streamsapi_bridge';
import DeleteOrder from '../../views/popups/phonenumbers/DeleteOrder';
import ValidatedOrderDetails from '../../views/popups/phonenumbers/ValidatedOrderDetails';
import PopupLoader from '../../views/popups/PopupLoader';
import TNLocalNumber from '../../views/popups/phonenumbers/TNLocalNumber';
import { uploadIcon } from '../images';
import TopSuccess from '../header/TopSuccess';
import TopMessage from '../header/TopMessage';
import { customSearch, useAutoFocusSearchAfterLoads } from '../CustomSearchUtil/CustomSearch';
import UIConstant from '../../apiclients/UIConstant';
import TNPorting from './TNporting';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import TabIDConstant from '../../apiclients/TabIDConstant';

function TNPortingValidationStatus(props) {

    const [isloading, setIsloading] = useState(true);
    const [portingDetails, setPortingDetails] = useState([]);
    const [deleteOrder, setDeleteOrder] = useState(false);
    const [selectedOrderId, setSelectedOrderId] = useState();
    const dtogglePopup = () => { setDeleteOrder(!deleteOrder) };
    const [draftInfo, setDraftInfo] = useState({});
    const [portType, setportType] = useState(1);
    const [centredModal2, setCentredModal2] = useState(false);
    const [portingType, setportingType] = useState(1);
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const toggleOpen2 = () => setCentredModal2(!centredModal2);
    const [portingSave, setportingSave] = useState(false);
    const [TabSwitchWarn, setTabSwitchWarn] = useState(false);
    const TabSwitch = () => setTabSwitchWarn(!TabSwitchWarn);
    const [uploadFiles, setuploadFiles] = useState([]);
    const [existingFiles, setexistingFiles] = useState([]);
    const [deletedFiles, setdeletedFiles] = useState([]);
    const [popoverModal, setPopoverModal] = useState(false);
    const [portingId, setportingId] = useState("");
    const toggleOpennew = () => setPopoverModal(!popoverModal);
    const [rerender, setrerender] = useState(false);
    const [internalError, setInternalError] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [filteredRows, setFilteredRows] = useState([]);
    const [tnPortingDetails, setTnPortingDetails] = useState([]);
    const [successMessage, setSuccessMessage] = useState("");
    const [isDraft, setisDraft] = useState(false);
    const [modalHeading, setModalHeading] = useState(t('TNPortingValidation'));
    const [closeFlag, setcloseFlag] = useState(false);
    const [portingName, setportingName] = useState("");
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);


    useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,props.isActive)
    useEffect(() => {
        if (successMessage) {
            setTimeout(() => {
                setSuccessMessage(""); // Clear the success message in the parent component
            }, 5000);
        }
    }, [successMessage]);

    const handleClose = (e) => {
        e?.preventDefault();
        e?.stopPropagation();
        if (portingSave && isDraft && !closeFlag) {
            TabSwitch();

        } else {
            setCentredModal2(false);
            setModalHeading(t("TNPortingValidation"));
            setModalHeading(t("TNPortingValidation"));
            navigate("/phonenumbers", {
                state: { tab: "tab4" },
            });

            window.location.reload();
        }

    }

    function deleteThisOrder(evntData, orderStatus, orderId, portType) {
        evntData.preventDefault();
        evntData.stopPropagation();
        //  if(orderStatus == 'Saved as Draft'){

        setSelectedOrderId(orderId);
        setportingName(portType);
        setDeleteOrder(true);
        //}
    }

    async function fetchData() {
        setIsloading(true);
        const response = await getPortingStatusDetails(JSON.parse(sessionStorage.getItem("admin_session")).siteid, TabIDConstant.NUM_PORTING_SUBLINK);
        const rawData = await response.json();
        setPortingDetails(rawData?.tn_phone_numbers ?? []);
        setIsloading(false);
    }
    async function handleSaveAsDraft(orderid) {
        try {

            console.log(`Order Id ::${orderid}`);
            let apiResponse = await getPortingDetails(JSON.parse(sessionStorage.getItem("admin_session")).siteid, orderid);
            let resData = await apiResponse.json();
            if (apiResponse.status == 200) {
                console.log("response ::::::::::::::::::: " + JSON.stringify(resData));
                setDraftInfo(resData?.tn_order_details ?? {});
                setportType(resData?.tn_order_details?.port_type ?? 1);
                setModalHeading(resData?.tn_order_details?.port_type ? resData?.tn_order_details?.port_type === 1 ? t("TNPortings") : resData?.tn_order_details?.port_type === 2 ? t("TFNPorting") : t("ValidateNumbers") : t("TNPortings"));
                setCentredModal2(true);
            } else {
                // setInternalError(true);
            }
        } catch (e) {
            console.log(`Unable to process Request :Internal server Error:!`);
            // setInternalError(true);
        }


    }

    const handleUploadCob = (e, portId, oldUploadedFiles, portType) => {
        e.preventDefault();
        e.stopPropagation();
        setSelectedOrderId(portId);
        setexistingFiles(oldUploadedFiles);
        setportType(parseInt(portType));
        setUploadedFiles([]);
        setdeletedFiles([]);
        toggleOpennew();

    }

    useEffect(() => {
        let processdrows = [];
        portingDetails.map((orderObj) => {

            processdrows.push({
                order_id: orderObj.order_id,
                upload_btn: (
                    (["Pending", "FOC Secured-Partial", "Jeopardy"].includes(orderObj.status) &&
                        ["TN Porting", "TFN Porting"].includes(orderObj.order_type)) && (
                        <>
                            <div className="tnupload-btn">
                                <MDBBtn outline className='d-flex align-items-center justify-content-center border-0' onClick={(e) => handleUploadCob(e, orderObj.order_id, orderObj.cob_files, (orderObj.order_type === "TN Porting" ? 1 : orderObj.order_type === "TFN Porting" ? 2 : 3))}>
                                    <MDBIcon fas icon='upload' className='m-0' size='sm' />
                                </MDBBtn>
                            </div>
                        </>
                    )
                ),

                status: (orderObj.status + ' ' + (orderObj.validated_date ?? '')),
                order_type: orderObj.order_type ?? "",
                created_date: orderObj.created_date ?? "",
                completed_date: orderObj.completed_date ?? '',
                ...((orderObj.status == 'Saved as Draft') && {
                    delete: (
                        <>

                            <div className="d-flex align-items-center justify-content-center">
                                <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(e) => deleteThisOrder(e, `${orderObj.status}`, `${orderObj.order_id}`, `${orderObj.order_type}`)}>
                                    <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
                                </div>
                            </div>
                        </>
                    )
                }),

            })
        })
        setFilteredRows(processdrows);
        setTnPortingDetails(processdrows)
        setDataLoaded(true)
    }, [portingDetails])
    // Fetching the data for display
    useEffect(() => {
        if (props.isActive || rerender) {
            fetchData();
            setrerender(false);
        }
    }, [props.isActive, rerender]);


    const actionData = {
        columns: [
            { label: 'Order Number', field: 'order_id' },
            { label: '', field: 'upload_btn', sort: false },
            { label: 'Status', field: 'status' },
            { label: 'Request Type', field: 'order_type' },
            { label: 'Date Created', field: 'created_date' },
            { label: 'Date Completed / Cancelled', field: 'completed_date' },
            { label: 'Remove', field: 'delete', sort: false },
        ],
        rows: tnPortingDetails
    }
    const handleManualSearch = (searchValue) => {
        setSearchValue(searchValue);
        const filtered = customSearch(tnPortingDetails, searchValue, UIConstant.TN_PORTING_VALIDATION_STATUS);

        setFilteredRows(filtered);
    };

    const [basicModal, setBasicModal] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const toggleOpen = () => setBasicModal(!basicModal);


    const handleFileChange = (event) => {
        const files = event.target.files;
        const newUploadedFiles = [...uploadedFiles]; // Copy existing files

        const oldUploadedFiles = existingFiles.map((file) => file.cob_filename);
        let existingFilesList = uploadedFiles.map((file) => file.name);
        existingFilesList = [...existingFilesList, ...oldUploadedFiles];
        const duplicates = (Array.from(event.target.files)).filter((file) =>
            existingFilesList.includes(file.name)
        );
        // event.target.value = "";
        if (duplicates && duplicates.length > 0) {
            const name = duplicates.map((file) => file.name);
            alert(`Files ${name.join(", ")} are duplicate`);
            return;
        }

        if (existingFiles.length + files.length > 10) {
            alert("Maximum 10 PDF files can be uploaded.");
            return;
        }

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (file.type !== "application/pdf") {
                alert(`Upload only PDF File.`);
                return;
            }
            const fileSizeInMB = file.size / (1024 * 1024); // Convert bytes to MB

            if (fileSizeInMB <= 25) { // Check if file size is within limit
                newUploadedFiles.push(file);
            } else {
                alert(`File '${file.name}' exceeds the maximum file size of 25 MB.`);
            }
        }

        setUploadedFiles(newUploadedFiles);
    };

    const handleDeleteFile = (index) => {
        const newUploadedFiles = [...uploadedFiles];
        newUploadedFiles.splice(index, 1);
        setUploadedFiles(newUploadedFiles);
    };
    const handleDeleteExistingFiles = (e, fileid) => {
        e.preventDefault();
        const updatedList = existingFiles.filter((file) => parseInt(file.id) !== parseInt(fileid));
        setexistingFiles(updatedList);
        setdeletedFiles((prev) => [...prev, fileid]);
        // const newUploadedFiles = [...uploadedFiles];
        // newUploadedFiles.splice(index, 1);
        // setUploadedFiles(newUploadedFiles);
    };

    async function handleSubmit(e) {
        e.preventDefault();
        e.stopPropagation();
        const formData = new FormData();
        formData.append("reqid", portType === 1 ? 91 : portType === 2 ? 95 : 96);
        formData.append("orderid", selectedOrderId);
        formData.append("flow_step", portType === 1 ? 8 : portType === 2 ? 9 : 5);
        formData.append("port_type", parseInt(portType));
        formData.append(
            "siteid",
            JSON.parse(sessionStorage.getItem("admin_session")).siteid
        );

        if (uploadedFiles.length > 0) {
            uploadedFiles.forEach((file) => {
                formData.append("upload_latest_bill", file, file.name);
            });
        }
        if (deletedFiles.length > 0) {
            formData.append("deletepdfs", deletedFiles);
        }

        setIsloading(true);
        let saverep = await uploadCobFile(formData);
        setIsloading(false);
        console.log(`reponse of next :::: ${JSON.stringify(saverep)}`);
        let saverepeMsg = await saverep.json();
        console.log("response of next:::" + JSON.stringify(saverepeMsg));
        if (saverepeMsg.status && saverepeMsg.status == "success") {
            setSuccessMessage(saverepeMsg.message);
            setrerender(true);
            toggleOpennew();
            // setorderID(saverepeMsg.order_id);

        } else {
            setInternalError(true);
            toggleOpennew();
        }

    }


    useEffect(() => {
        const patchTitles = () => {
            const tds = document.querySelectorAll('table td');
            tds.forEach(td => {
                const trimmed = td.textContent.trim();
                if (!td.getAttribute('title') || td.getAttribute('title') !== trimmed) {
                    td.setAttribute('title', trimmed);
                }
            });
        };

        patchTitles();

        const table = document.querySelector('.TNPhoneNumbersData-Table');

        if (!table) return;

        const observer = new MutationObserver(() => {
            patchTitles();
        });

        observer.observe(table, {
            childList: true,
            subtree: true,
        });

        return () => observer.disconnect();
    }, []);



    return (
        <>
            <div className="TNPortingDataTable">
                <div className="actionbar"></div>
                <div className='mb-2 mt-0 position-relative w-auto'>
                    <MDBInput
                        label="Search"
                        ref={searchRef}
                        value={searchValue}
                        onChange={(e) => handleManualSearch(e.target.value)}
                    />
                    <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                </div>
                <MDBDatatable
                    key={searchValue} 
                    className="TNPhoneNumbersData-Table actioncolumn"
                    onRowClick={(evnt) => {
                        if (evnt.status.indexOf("Saved as Draft") != -1) {
                            handleSaveAsDraft(evnt.order_id);

                        } else {
                            setBasicModal(!basicModal);
                            setSelectedOrderId(evnt.order_id)
                            setportingType(evnt.order_type === "TN Porting" ? 1 : evnt.order_type === "TFN Porting" ? 2 : 3);
                        }
                    }}
                    // search
                    fixedHeader
                    // sortField="Order Number"
                    hover
                    entries={50}
                    sortOrder="asc"
                    data={{ ...actionData, rows: filteredRows }}
                />
            </div>

            {basicModal && (
                <PopupLoader
                    size={'lg'}
                    title={<div className="d-flex align-items-center">

                        {portingType === 3 && (<MDBIcon fas icon="check-circle" className='fs-5' color='success' />)}
                        <div className="ms-3 fw-bold fs-5">
                            {portingType === 3 ? "Validated" : "Status"}
                        </div>
                    </div>}
                    content={<ValidatedOrderDetails orderId={selectedOrderId} onClose={toggleOpen} portingType={portingType} />}
                    onShow={setBasicModal}
                    onClose={toggleOpen}
                />
            )
            }

            {deleteOrder && (
                <PopupLoader
                    title={"Remove Order"}
                    content={<DeleteOrder orderId={selectedOrderId} portingName={portingName} onClose={dtogglePopup} />}
                    onShow={setDeleteOrder}
                    onClose={dtogglePopup}
                />
            )}

            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}

            {/* <MDBModal open={centredModal2} onClose={(e) => { alert("hiiii"); handleClose(e);}} tabIndex='-1'>
                <MDBModalDialog size="fullscreen">
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle className="d-flex align-items-center justify-content-center">
                                {modalHeading}
                            </MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClose={(e) => { alert("hiiii");handleClose(e); }}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody className="fullPageModel">
                    
                            <TNPorting
                                setSuccessMessage={setSuccessMessage}
                                closePopup={(e) => { handleClose(e); }}
                                portingSave={portingSave}
                                setportingSave={setportingSave}
                                TabSwitchWarn={TabSwitchWarn}
                                setTabSwitchWarn={setTabSwitchWarn}
                                setCentredModal2={setCentredModal2}
                                setModalHeading={setModalHeading}
                                setIsDraft={setisDraft}
                                draftPortingType={portType}
                                draftInfo={draftInfo}
                            />
                        </MDBModalBody>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal> */}




            <MDBModal tabIndex='-1' open={popoverModal} onClose={() => setPopoverModal(false)}>
                <MDBModalDialog size='xl'>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Upload Latest Bill(s) - {selectedOrderId}</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={toggleOpennew}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <div className='h-100'>
                                <div className="d-flex align-items-center justify-content-center p-3 flex-column">
                                    <h5>Upload Latest Copy of Bill or Customer Service Record</h5>



                                    <div className="uploadOuter mt-3 w-80 sm-w-100">
                                        <span className="dragBox2 upload-content w-60 sm-w-100">
                                            <span>
                                                <img src={uploadIcon} className="upload-img" alt="Upload Icon" />
                                            </span>
                                            <span>Drag and Drop to upload Files</span>
                                            <small className="text-secondary mt-2">Maximum of 10 PDF files (Max file size: 25 MB) can be uploaded!</small>
                                            <input
                                                type="file"
                                                id="uploadFile"
                                                className="upload__img LOA"
                                                onChange={handleFileChange}
                                                multiple
                                                accept=".pdf"
                                            />
                                        </span>
                                    </div>

                                    <div className='w-80'>
                                        {existingFiles?.length > 0 && (
                                            <div className='d-flex  align-items-center justify-content-center flex-column'>
                                                {existingFiles.map((files, index) => (
                                                    <div className='border p-2 mt-2 rounded bg-light w-60 d-flex align-items-center justify-content-between'>
                                                        <span>{files.cob_filename}</span>
                                                        <MDBIcon fas icon="times" className='cursor-pointer' onClick={(e) => handleDeleteExistingFiles(e, files.id)} />
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                    <div className='w-80'>
                                        {uploadedFiles.length > 0 && (
                                            <div className='d-flex  align-items-center justify-content-center flex-column'>
                                                {uploadedFiles.map((fileName, index) => (
                                                    <div className='border p-2 mt-2 rounded bg-light w-60 d-flex align-items-center justify-content-between'>
                                                        <span>{fileName.name}</span>
                                                        <MDBIcon fas icon="times" className='cursor-pointer' onClick={() => handleDeleteFile(index)} />
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>



                                    <p className='mt-2'><b>Note: </b>
                                        Please upload the latest copy of Bill for the added phone number(s) that can evidence that you own the phone number(s).</p>
                                </div>

                            </div>
                        </MDBModalBody>

                        <MDBModalFooter>
                            <MDBBtn color='secondary' onClick={toggleOpennew}>
                                Cancel
                            </MDBBtn>
                            <MDBBtn disabled={(uploadedFiles?.length === 0 && deletedFiles?.length === 0) || (uploadedFiles?.length === 0 && existingFiles?.length === 0)} onClick={(e) => handleSubmit(e)}>Submit</MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>


            <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                Remove
            </Tooltip>
            {successMessage && (
                <>
                    <TopSuccess>
                        <TopMessage successMessage={successMessage} />
                    </TopSuccess>
                </>
            )}
            {internalError && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={5000}
                    onClose={() => setInternalError(false)}
                >
                    Internal Server Error
                </MDBAlert>
            )}


            <MDBModal open={centredModal2} onClose={(e) => { handleClose(e); }} tabIndex='-1' appendToBody >
                <MDBModalDialog size="fullscreen">
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle className="d-flex align-items-center justify-content-center">
                                {modalHeading}
                            </MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={(e) => { handleClose(e); }}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody className="fullPageModel">
                            <TNPorting
                                setSuccessMessage={setSuccessMessage}
                                closePopup={(e) => { handleClose(e); }}
                                portingSave={portingSave}
                                setportingSave={setportingSave}
                                TabSwitchWarn={TabSwitchWarn}
                                setTabSwitchWarn={setTabSwitchWarn}
                                setCentredModal2={setCentredModal2}
                                setModalHeading={setModalHeading}
                                setIsDraft={setisDraft}
                                draftPortingType={portType}
                                draftInfo={draftInfo}
                                setcloseFlag={setcloseFlag}
                            />

                        </MDBModalBody>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>




        </>
    )
}

export default TNPortingValidationStatus
